<template>
  <div class="page-container">
    <div class="page-header">
      <div class="header-content">
        <h2>产品管理</h2>
        <span class="desc">-发布和管理金融产品</span>
      </div>
      <div class="header-right">
        <i class="el-icon-refresh" @click="refreshList" />
        <el-button
          type="primary"
          class="add-btn"
          @click="handleAddProduct"
        >+ 发布新产品</el-button>
      </div>
    </div>

    <div v-loading="loading" class="list-container">
      <div v-if="productList.length > 0" class="product-list">
        <div
          v-for="product in productList"
          :key="product.id"
          class="product-card"
        >
          <div class="product-header">
            <div
              :class="[
                'product-icon',
                product.productType == '1' ? 'icon-blue' : 'icon-green'
              ]"
            >
              {{ product.productType == '1' ? '农' : '企' }}
            </div>
            <div class="product-info">
              <h3 class="product-name">{{ product.productName }}</h3>
              <p
                :class="[
                  'product-desc',
                  product.productDescription ? '' : 'no-desc'
                ]"
              >
                {{ product.productDescription || '暂无' }}
              </p>
            </div>
          </div>

          <div class="product-details">
            <div class="detail-item">
              <span class="detail-label">贷款额度</span>
              <span
                class="detail-value"
              >{{ product.minQuota }}-{{ product.maxQuota }}万</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">年利率</span>
              <span
                class="detail-value"
              >{{ product.minRate }}-{{ product.maxRate }}%</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">贷款期限</span>
              <span
                class="detail-value"
              >{{ product.minTerm }}-{{ product.maxTerm }}月</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">状态</span>
              <span
                :class="[
                  'detail-value status',
                  product.productState == '1'
                    ? 'status-active'
                    : 'status-paused'
                ]"
              >{{ product.productState == '1' ? '在售' : '暂停' }}</span>
            </div>
          </div>

          <div class="product-actions">
            <el-button
              v-if="product.productState == '0'"
              type="primary"
              @click="handleEditProduct(product)"
            >
              编辑
            </el-button>
            <el-button
              v-if="product.productState == '1'"
              type="warning"
              @click="handlePauseProduct(product, '0')"
            >
              暂停
            </el-button>
            <el-button
              v-else
              type="success"
              @click="handlePauseProduct(product, '1')"
            >
              激活
            </el-button>
            <el-button
              v-if="product.productState == '0'"
              type="danger"
              @click="handleDeleteProduct(product)"
            >
              删除
            </el-button>
          </div>
        </div>
      </div>
      <el-empty
        v-else
        style="margin-top: 150px"
        image="https://oss.yungia.cn/yjkjoss/group1/M00/01/7D/wKgBcmlCScKAWpSFAAAozJyBfZA665.png"
        image-style="height: 120px"
        description="暂无产品信息"
      />
    </div>

    <div class="pagination-container">
      <pub-pagination
        :total="total"
        :page-num="queryParams.pageNum"
        :page-size="queryParams.pageSize"
        :page-sizes="[9, 18, 27]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 产品发布/编辑弹窗 -->
    <product-dialog ref="productDialog" @refresh="getList" />
  </div>
</template>

<script>
import { api_getPageList, api_updateStatus, api_delete } from '@/api/loans.js';
import pubPagination from '@/components/pubPagination.vue';
import ProductDialog from '@/components/ProductDialog.vue';
import constant from '@/utils/constants.js';
export default {
  name: 'ProductList',
  components: {
    pubPagination,
    ProductDialog
  },
  data() {
    return {
      productTypeList: constant.productTypeList,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 9
      },
      total: 0, // 总记录数
      productList: []
    };
  },

  mounted() {
    // 初始化加载产品列表数据
    this.getList();
  },
  methods: {
    handleAddProduct() {
      // 发布新产品
      this.$refs.productDialog.openDialog();
    },
    handleEditProduct(product) {
      // 编辑产品
      this.$refs.productDialog.openDialog(product);
    },
    handleDeleteProduct(product) {
      // 删除产品的逻辑
      this.$confirm(`确定要删除产品 "${product.productName}" 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async() => {
          try {
            // 调用删除产品的API
            await api_delete({
              id: product.id
            });
            // 更新产品状态
            this.$message.success(`已删除`);
            // 刷新产品列表数据
            this.refreshList();
          } catch (error) {
            console.error('删除产品失败:', error);
            // this.$message.error('删除产品失败，请稍后重试');
          }
        })
        .catch(() => {
          console.log('已取消删除操作');
        });
    },
    handlePauseProduct(product, status) {
      // 暂停产品的逻辑
      this.$confirm(
        `确定要${status === '0' ? '暂停' : '激活'}产品 "${
          product.productName
        }" 吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(async() => {
          try {
            // 调用暂停产品的API
            await api_updateStatus({
              id: product.id
              // productState: status === '0' ? '1' : '0'
            });
            // 更新产品状态
            this.$message.success(`已${status === '0' ? '暂停' : '激活'}`);
            // 刷新产品列表数据
            this.refreshList();
          } catch (error) {
            console.error('暂停产品失败:', error);
            // this.$message.error('暂停产品失败，请稍后重试');
          }
        })
        .catch(() => {
          console.log('已取消暂停操作');
        });
    },
    updateProductIcon(product) {
      // 根据产品类型设置图标和颜色
      switch (product.type) {
        case 'credit':
          product.icon = 'el-icon-user';
          product.iconClass = 'icon-purple';
          break;
        case 'mortgage':
          product.icon = 'el-icon-home';
          product.iconClass = 'icon-orange';
          break;
        case 'guarantee':
          product.icon = 'el-icon-shield';
          product.iconClass = 'icon-blue';
          break;
        case 'other':
          product.icon = 'el-icon-coffee-cup';
          product.iconClass = 'icon-green';
          break;
        default:
          product.icon = 'el-icon-money';
          product.iconClass = 'icon-blue';
      }
    },
    handleSizeChange(size) {
      // 每页显示数量变化的处理
      this.queryParams.pageSize = size;
      this.queryParams.pageNum = 1;
      // 这里应该调用API获取数据
      this.getList();
    },
    handleCurrentChange(current) {
      // 当前页码变化的处理
      this.queryParams.pageNum = current;
      // 这里应该调用API获取数据
      this.getList();
    },
    refreshList(reload = true) {
      // 刷新产品列表数据
      if (reload) {
        this.queryParams.pageNum = 1;
      }
      this.getList();
    },
    async getList() {
      // 实际项目中应该调用API获取数据
      this.loading = true;
      try {
        const res = await api_getPageList(this.queryParams);
        this.productList = res.data.rows || [];
        this.total = res.data.total || 0;
        this.loading = false;
      } catch (error) {
        console.error('获取产品列表失败:', error);
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.header-right {
  display: flex;
  align-items: center;
}
.header-right .el-icon-refresh {
  font-size: 20px;
  margin-right: 12px;
  cursor: pointer;
}
/* 产品列表样式 */
.product-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

/* 产品卡片样式 */
.product-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: box-shadow 0.3s ease;
}

.product-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.product-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.product-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-right: 16px;
}

.product-icon.icon-green {
  background-color: #f0f9eb;
  color: #67c23a;
}

.product-icon.icon-blue {
  background-color: #ecf5ff;
  color: #409eff;
}

.product-icon.icon-purple {
  background-color: #f5f0ff;
  color: #909399;
}

.product-icon.icon-orange {
  background-color: #fff7e6;
  color: #e6a23c;
}
.product-info {
  flex: 1;
  width: 0;
}
.product-info h3 {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 5px 0;
  color: #333;
}

.product-desc {
  font-size: 14px;
  color: #666;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-desc.no-desc {
  color: #909399;
}

.product-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.detail-item {
  display: flex;
  flex-direction: column;
}

.detail-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.detail-value {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.status {
  display: inline-block;
  width: fit-content;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.status-active {
  background-color: #f0f9eb;
  color: #67c23a;
}

.status-paused {
  background-color: #fef0f0;
  color: #f56c6c;
}

.product-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.product-actions .el-button {
  font-size: 12px;
  padding: 4px 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .product-list {
    grid-template-columns: 1fr;
  }

  .product-details {
    grid-template-columns: 1fr;
  }
}
</style>
